/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type MatchupAdvantageTableDefenseQueryVariables = {||};
export type MatchupAdvantageTableDefenseQueryResponse = {|
  +nflDefensiveMatchupRankings: ?$ReadOnlyArray<?{|
    +team: {|
      +abbreviation: string,
      +name: ?string,
    |},
    +opp: {|
      +abbreviation: string,
      +name: ?string,
    |},
    +teamTotal: any,
    +gameTotal: any,
    +defenseRank: number,
  |}>
|};
export type MatchupAdvantageTableDefenseQuery = {|
  variables: MatchupAdvantageTableDefenseQueryVariables,
  response: MatchupAdvantageTableDefenseQueryResponse,
|};
*/


/*
query MatchupAdvantageTableDefenseQuery {
  nflDefensiveMatchupRankings {
    team {
      abbreviation
      name
      id
    }
    opp {
      abbreviation
      name
      id
    }
    teamTotal
    gameTotal
    defenseRank
    id
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "abbreviation",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v2 = [
  (v0/*: any*/),
  (v1/*: any*/)
],
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "teamTotal",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "gameTotal",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "defenseRank",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v7 = [
  (v0/*: any*/),
  (v1/*: any*/),
  (v6/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "MatchupAdvantageTableDefenseQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "NFLDefensiveMatchupRankingsType",
        "kind": "LinkedField",
        "name": "nflDefensiveMatchupRankings",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "NFLStatTeamType",
            "kind": "LinkedField",
            "name": "team",
            "plural": false,
            "selections": (v2/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "NFLStatTeamType",
            "kind": "LinkedField",
            "name": "opp",
            "plural": false,
            "selections": (v2/*: any*/),
            "storageKey": null
          },
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "MatchupAdvantageTableDefenseQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "NFLDefensiveMatchupRankingsType",
        "kind": "LinkedField",
        "name": "nflDefensiveMatchupRankings",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "NFLStatTeamType",
            "kind": "LinkedField",
            "name": "team",
            "plural": false,
            "selections": (v7/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "NFLStatTeamType",
            "kind": "LinkedField",
            "name": "opp",
            "plural": false,
            "selections": (v7/*: any*/),
            "storageKey": null
          },
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/),
          (v6/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "cba3d2febd3139911bb2d756734b5ca8",
    "id": null,
    "metadata": {},
    "name": "MatchupAdvantageTableDefenseQuery",
    "operationKind": "query",
    "text": "query MatchupAdvantageTableDefenseQuery {\n  nflDefensiveMatchupRankings {\n    team {\n      abbreviation\n      name\n      id\n    }\n    opp {\n      abbreviation\n      name\n      id\n    }\n    teamTotal\n    gameTotal\n    defenseRank\n    id\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'f6ffb019cf509e1a487a05fe0c66df70';

module.exports = node;
